import { useEffect } from "react";
import { connect } from "react-redux";
import { FornecedorViewProps, mapDispatchToFornecedorProps, mapStateToFornecedorProps } from "../forn.controll";
import { Autocomplete, Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import { Fornecedor } from "../forn.model";
import { ArrowDropDown, Search } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";
import Modal from "../../../components/modal";
import { columnsFornecedor } from "./forn.list";
import { Select as ViewList } from "../../../components/select";
import { FornecedorCadastro } from "./forn.cad";


interface FornecedorAutoCompletProps extends FornecedorViewProps {
    handleSelectFornecedor: (row: Fornecedor) => any
}


function FornecedorAutoComplete(props: FornecedorAutoCompletProps) {
    const { fornecedorActions, fornecedorState, handleSelectFornecedor } = props
    const { rows } = fornecedorState
    useEffect(() => {
        console.log("chamou FornecedorAutoComplete")
        if (rows.length === 0) {
            fornecedorActions.read();
        }
    }, [])

    const handleSelect = (row: Fornecedor) => {
        console.log("selecionou fornecedor " + row)
        handleSelectFornecedor(row)
    }

    return (
        <Autocomplete
            fullWidth
            options={rows}
            autoHighlight
            getOptionLabel={(fornecedor) => fornecedor.nome}
            getOptionKey={(fornecedor) => fornecedor._id}
            title="Selecionar Fornecedor"
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            disableClearable
            //popupIcon={<Search fontSize="small"  titleAccess="Selecionar Fornecedor"/>}
            clearIcon={<ClearIcon fontSize="small" titleAccess="Remover" />}
            renderOption={((props, fornecedor) => {
                const { key, ...optionProps } = props
                return (
                    <Box
                        key={key}
                        component={"li"}
                        {...optionProps}
                    >
                        <Stack flexDirection={"column"}>
                            <Typography variant="body1">{fornecedor.nome}</Typography>
                            <Typography variant="caption">{fornecedor.whatsapp}</Typography>
                        </Stack>
                    </Box>
                )
            })}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label="Selecionar Fornecedor"
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        },
                    }}
                />
            }
            onChange={(ev, fornecedor) => {
                ev.preventDefault();
                if (fornecedor)
                    handleSelect(fornecedor);
            }}
        />
    )
}
interface SelecionarFornecedorProps extends FornecedorViewProps {
    handleConfirmar: (fornecedor: Fornecedor) => any;
}

function SelecionarFornecedor(props: SelecionarFornecedorProps) {
    const { fornecedorActions, fornecedorState, handleConfirmar } = props
    const { error, loading, msg, row, rows, showAlert, status, showCadModal, changeList, showSelectModal } = fornecedorState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = fornecedorActions

    useEffect(() => {
        console.log("chamou Selecionar Fornecedor")
        if (rows.length === 0) {
            fornecedorActions.read();
        }
    }, [])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    function Cadastro() {
        return FornecedorCadastro({
            ...props,
            handleCloseView: () => setShowCadModal(false)
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            heigth: "auto",
        })
    }

    const handleSelecionar = (fornecedor:Fornecedor) => {
        handleConfirmar(fornecedor);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Fornecedor"}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: Fornecedor) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    multFieldSearch
                    fieldSearch={["nome","whatsapp"]}
                    placeholderTextSearch="Buscar nome ou whatsapp"
                    variantToobar="dense" 
                    columns={columnsFornecedor}
                    rows={rows}
                    loading={loading}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: true,
                        onClick: handleNovo
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => read()
                    }}
                    ListItemTextPrimary={(row: Fornecedor) => <Typography component={"span"}>{row.nome} {row.sobrenome}</Typography>}
                    ListItemTextSecondary={(row: Fornecedor) =>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography component={"span"}>{row.apelido} {row.whatsapp}</Typography>
                            {row.enderecos.length > 0 && (
                                <Typography component={"span"}>{row.enderecos[row.idx_endereco_main].rua}</Typography>
                            )}

                        </Box>
                    }
                />
                <Cadastro />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="md"
            handleOnKeyDown={() => { }}
        />
    )
}

export default connect(mapStateToFornecedorProps, mapDispatchToFornecedorProps)(FornecedorAutoComplete)
export const ViewSelecionarFornecedor = connect(mapStateToFornecedorProps, mapDispatchToFornecedorProps)(SelecionarFornecedor)